import "../style.css";

const path = window.location.pathname.toLowerCase().replace(/\/+$/, "") || "/";

function hasSelector(selector: string): boolean {
    return document.querySelector(selector) !== null;
}

async function bootIsland() {
    console.log("[islands] boot", {
        path,
        login: hasSelector("#login-island"),
        home: hasSelector("#home-island"),
        dashboard: hasSelector("#dashboard-island"),
        usekey: hasSelector(".use-key-btn"),
        keydetails: hasSelector("#keydetails-island, #key-details-island")
    });

    // Login Razor page
    if (hasSelector("#login-island")) {
        console.log("[islands] loading Login.ts");
        await import("./Login");
    }

    // Dashboard Razor page
    if (hasSelector("#dashboard-island") || path.startsWith("/dashboard")) {
        console.log("[islands] loading Dashboard.ts");
        await import("./Dashboard");
    }

    // Home Razor island
    if (hasSelector("#home-island")) {
        console.log("[islands] loading home.ts");
        await import("./Home");
    }

    // Home/usekey buttons
    if (
        hasSelector(".use-key-btn") ||
        hasSelector("#usekey-island") ||
        hasSelector("#use-key-island")
    ) {
        console.log("[islands] loading usekey.ts");
        await import("./usekey");
    }

    // Key details Razor page
    if (
        hasSelector("#keydetails-island") ||
        hasSelector("#key-details-island") ||
        path.startsWith("/keydetails") ||
        path.startsWith("/key-details")
    ) {
        console.log("[islands] loading keydetails.ts");
        await import("./keydetails");
    }
}

bootIsland().catch(err => {
    console.error("[islands] Failed to boot island:", err);
});